var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,209,239)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "94%",
    style: {
      stopColor: "rgb(245,250,195)",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pathSpinner",
    d: "M11.8001 5.74765L15.4001 7.90765L20.6289 5.29165L11.8001 0.139648V5.74765ZM10.2001 0.141248L1.3713 5.29165L6.6001 7.90605L10.2001 5.74605V0.141248ZM0.600098 6.69485V15.37L6.2001 12.8805V9.49645L0.600098 6.69485ZM1.4369 16.7477L10.2001 21.8596V16.2533L6.9457 14.3012L1.4369 16.7493V16.7477ZM11.8001 21.8596L20.5633 16.7477L15.0545 14.2997L11.8001 16.2533V21.8596ZM21.4001 15.3684V6.69645L15.8001 9.49645V12.882L21.4001 15.3717V15.3684ZM11.8001 14.3876L14.2001 12.9476V10.2948L11.8001 11.4948V14.3876ZM10.2001 11.4948V14.3876L7.8001 12.9476V10.2948L10.2001 11.4948ZM8.2977 8.75405L11.0001 10.106L13.7025 8.75405L11.0001 7.13325L8.2977 8.75405Z",
    fill: "url(#grad1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.a333abd77b02077863055f66e876e5e9.svg";
export { ForwardRef as ReactComponent };